module.exports = __webpack_public_path__ + "img/filter.0ffb80cd.svg";